import {ComponentRegistry} from '@enonic/react-components';
import {DefaultPage} from './components/DefaultPage';
import {HeroStandard} from './components/HeroStandard';
import {ClientLogoBar} from './components/ClientLogoBar';
import {ContentBlock} from './components/ContentBlock';
import {ExpandableLinkList} from './components/ExpandableLinkList';
import {HeroInteractive} from './components/HeroInteractive';
import {FeaturedCards} from './components/FeaturedCards';
import {ListPeople} from './components/ListPeople';
import {NewsletterSignup} from './components/NewsletterSignup';
import {CardGrid} from './components/CardGrid';
import {KeyData} from './components/KeyData';
import {CardCarousel} from './components/CardCarousel';
import {CardSelection} from './components/CardSelection';
import {Quote} from './components/Quote';
import {TextBlock} from './components/TextBlock';
import {ContactForm} from './components/ContactForm';
import {UpcomingEvents} from './components/UpcomingEvents';
import {ContactCta} from './components/ContactCta';
import {TwoColumnForm} from './components/TwoColumnForm';
import {ContentDownloadForm} from './components/ContentDownloadForm';
import {ImageBlock} from './components/ImageBlock';
import {Video} from './components/Video';
import {RelatedArticles} from './components/RelatedArticles';
import {Faq} from './components/Faq';
import {EventAgenda} from './components/EventAgenda';
import {LocationMap} from './components/LocationMap';
import {Vacancies} from './components/Vacancies';
import {HubspotForm} from './components/HubspotForm';
import {ArticleList} from './components/ArticleList';
import {ReferenceList} from './components/ReferenceList';
import {EventList} from './components/EventList';
import {JobOfferings} from './components/JobOfferings';
import {Reference} from './components/Reference';
import {ArticleLayout} from './components/ArticleLayout';
import {EventLayout} from './components/EventLayout';
import {QuoteMacro} from './components/QuoteMacro';
import {ImageBlockMacro} from './components/ImageBlockMacro';
import {VideoMacro} from './components/VideoMacro';
import {KeyDataMacro} from './components/KeyDataMacro';
import {ZohoJobListingMacro} from './components/ZohoJobListingMacro';
import {HubspotFormMacro} from './components/HubspotFormMacro';

export const componentRegistry = new ComponentRegistry();

componentRegistry.addPage('no.seeds.99x:default', {View: DefaultPage});

// Register content types / parts / layouts / pages here, e.g.:
// componentRegistry.addContentType('99x:employee', {View: Employee});

// Parts
componentRegistry.addPart('no.seeds.99x:hero-standard', {View: HeroStandard});
componentRegistry.addPart('no.seeds.99x:client-logo-bar', {View: ClientLogoBar});
componentRegistry.addPart('no.seeds.99x:content-block', {View: ContentBlock});
componentRegistry.addPart('no.seeds.99x:expandable-link-list', {View: ExpandableLinkList});
componentRegistry.addPart('no.seeds.99x:hero-interactive', {View: HeroInteractive});
componentRegistry.addPart('no.seeds.99x:featured-cards', {View: FeaturedCards});
componentRegistry.addPart('no.seeds.99x:list-people', {View: ListPeople});
componentRegistry.addPart('no.seeds.99x:newsletter-signup', {View: NewsletterSignup});
componentRegistry.addPart('no.seeds.99x:card-grid', {View: CardGrid});
componentRegistry.addPart('no.seeds.99x:key-data', {View: KeyData});
componentRegistry.addPart('no.seeds.99x:card-carousel', {View: CardCarousel});
componentRegistry.addPart('no.seeds.99x:card-selection', {View: CardSelection});
componentRegistry.addPart('no.seeds.99x:quote', {View: Quote});
componentRegistry.addPart('no.seeds.99x:text-block', {View: TextBlock});
componentRegistry.addPart('no.seeds.99x:contact-form', {View: ContactForm});
componentRegistry.addPart('no.seeds.99x:upcoming-events', {View: UpcomingEvents});
componentRegistry.addPart('no.seeds.99x:contact-cta', {View: ContactCta});
componentRegistry.addPart('no.seeds.99x:two-column-form', {View: TwoColumnForm});
componentRegistry.addPart('no.seeds.99x:content-download-form', {View: ContentDownloadForm});
componentRegistry.addPart('no.seeds.99x:image-block', {View: ImageBlock});
componentRegistry.addPart('no.seeds.99x:video', {View: Video});
componentRegistry.addPart('no.seeds.99x:related-articles', {View: RelatedArticles});
componentRegistry.addPart('no.seeds.99x:faq', {View: Faq});
componentRegistry.addPart('no.seeds.99x:event-agenda', {View: EventAgenda});
componentRegistry.addPart('no.seeds.99x:location-map', {View: LocationMap});
componentRegistry.addPart('no.seeds.99x:vacancies', {View: Vacancies});
componentRegistry.addPart('no.seeds.99x:hubspot-form', {View: HubspotForm});

// Layouts
componentRegistry.addLayout('no.seeds.99x:article-list', {View: ArticleList});
componentRegistry.addLayout('no.seeds.99x:reference-list', {View: ReferenceList});
componentRegistry.addLayout('no.seeds.99x:event-list', {View: EventList});
componentRegistry.addLayout('no.seeds.99x:job-offerings', {View: JobOfferings});
componentRegistry.addLayout('no.seeds.99x:reference', {View: Reference});
componentRegistry.addLayout('no.seeds.99x:article', {View: ArticleLayout});
componentRegistry.addLayout('no.seeds.99x:event', {View: EventLayout});

// Macros
componentRegistry.addMacro('quote', {View: QuoteMacro});
componentRegistry.addMacro('image-block', {View: ImageBlockMacro});
componentRegistry.addMacro('video', {View: VideoMacro});
componentRegistry.addMacro('key-data', {View: KeyDataMacro});
componentRegistry.addMacro('zoho-job-listing', {View: ZohoJobListingMacro});
componentRegistry.addMacro('hubspot-form', {View: HubspotFormMacro});
